import * as React from 'react';
import { FilespaceUsage, FilespaceLineItemWithForecast } from 'fs-api-client';
import FilespaceBreakdownBase, { FilespaceBreakdownBaseProperties } from './FilespaceBreakdownBase';
import { CheckBoldIcon } from './common/Icons';

interface FilespaceBreakdownForecastProps extends FilespaceBreakdownBaseProperties {
    filespaceBreakdown: FilespaceLineItemWithForecast[] | undefined;
}

interface FilespaceBreakdownForecastState {
}

class FilespaceBreakdownForecast extends FilespaceBreakdownBase<FilespaceBreakdownForecastProps, FilespaceBreakdownForecastState> {
    constructor(props: FilespaceBreakdownForecastProps) {
        super(props);
    }

    render() {
        const filespaceLineItems = this.props.filespaceBreakdown ? this.props.filespaceBreakdown : [];
        const tableHeaders = this.getTableHeaders(filespaceLineItems);
        return filespaceLineItems.length > 0 && (
            <div className="fix__container">
                <div className="table-container active">
                    <span className="box__label">Cost approximation per Filespace</span>
                    <table className="table">
                        {this.renderTableHeaders(tableHeaders)}
                        <tbody>
                            {filespaceLineItems.map(lineItem => this.renderFilespace(lineItem, tableHeaders))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderTableHeaders(columnDimensions: any[]) {
        return (
                <thead>
                    <tr>
                        <th scope="col" className="hidden left">Plan</th>
                        <th scope="col" className="left long">Filespace name</th>
                        <th scope="col" className={`hidden center`}>LucidLink Storage</th>
                        {columnDimensions.filter(header => header !== FilespaceUsage.DimensionEnum.Storage).map(header =>
                            (<th key={header} scope="col" className={`hidden`}>
                                {this.getDescriptionForDimension(header)}</th>))}
                        <th scope="col">Cost-to-date</th>
                        <th scope="col">Forecast</th>
                    </tr>
                </thead>
            );
    }

    renderFilespace(filespaceLineItem: FilespaceLineItemWithForecast, columnDimensions: any[]) {
        const amountDue = filespaceLineItem.amountDue;
        const amountDueForecast = filespaceLineItem.amountDueForecast;
        return (
            <tr key={filespaceLineItem.name} >
                {this.renderStorageType(filespaceLineItem)}
                <td className="left">
                    <strong title="development">{filespaceLineItem.name} </strong>
                </td>
                {filespaceLineItem.storageOwner === FilespaceLineItemWithForecast.StorageOwnerEnum.Lucidlink ?
                    (<td key={filespaceLineItem.name + FilespaceUsage.DimensionEnum.Storage} className="hidden green center">
                        <CheckBoldIcon width="15px" />
                    </td>) : (<td key={filespaceLineItem.name + FilespaceUsage.DimensionEnum.Storage}className="hidden"/>)
                }
                {columnDimensions.filter(dimension => dimension !== FilespaceUsage.DimensionEnum.Storage)
                                 .map((dimension: FilespaceUsage.DimensionEnum) => {
                    const dimensionUsage = filespaceLineItem.usageByDimension.find(usage => usage.dimension === dimension);
                    return (<td key={filespaceLineItem.name + dimension}className="hidden">
                                {dimensionUsage && this.renderUsage(dimensionUsage.dimension, dimensionUsage.usage)}
                            </td>);
                })}
                <td>${(amountDue / 100).toFixed(2)}</td>
                <td>${(amountDueForecast / 100).toFixed(2)}</td>
            </tr>
        );
    }
}

export default FilespaceBreakdownForecast;



// WEBPACK FOOTER //
// ./src/webportal/components/FilespaceBreakdownForecast.tsx